module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE1MCIgaGVpZ2h0PSIyNDgiIHZpZXdCb3g9IjAgMCAxMTUwIDI0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExNDkuNDkgMjQ4TDAuNTEwNzA4IDUuMzk0MjJlLTA2SDExNDkuNDlWMjQ4WiIgZmlsbD0iIzE5MUQyRiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/images/slice-bottom.svg
// module id = 499
// module chunks = 35783957827783